const getPeriodsInfo = (price) => {
    return {
        1: {
            title: 'Месяц',
            value: 1,
            price: price * 1,
            sale: 0,
            priceWithSale: price * 1,
        },
        3: {
            title: '3 месяца',
            value: 3,
            price: price * 3,
            sale: 15,
            priceWithSale: price * 3 * 0.85, // Скидка 15%
        },
        6: {
            title: '6 месяцев',
            value: 6,
            price: price * 6,
            sale: 25,
            priceWithSale: price * 6 * 0.75, // Скидка 25%
        },
        12: {
            title: '12 месяцев',
            value: 12,
            price: price * 12,
            sale: 35,
            priceWithSale: price * 12 * 0.65, // Скидка 35% (как на бэкенде)
        },
    };
};

export default getPeriodsInfo;
